import bezierEasing from 'bezier-easing'
import { Easing, JumpTerm } from '../../../types/prosentvis-bilde'
export function getEasing(easing: Easing = { type: 'linear' }) {
  switch (easing.type) {
    case 'ease':
      return bezierEasing(0.25, 0.1, 0.25, 1.0)
    case 'ease-in':
      return bezierEasing(0.42, 0, 1.0, 1.0)
    case 'ease-out':
      return bezierEasing(0, 0, 0.58, 1.0)
    case 'ease-in-out':
      return bezierEasing(0.42, 0, 0.58, 1.0)
    case 'cubic-bezier':
      return bezierEasing(easing.x1, easing.y1, easing.x2, easing.y2)
    case 'steps':
      return stepEasing(easing.n, easing.jumpterm)
    case 'linear':
    default:
      return bezierEasing(0.0, 0.0, 1.0, 1.0)
  }
}

const stepConfig = {
  'jump-start': {
    extraRise: 0,
    roundingFunction: Math.ceil,
  },
  'jump-end': {
    extraRise: 0,
    roundingFunction: Math.floor,
  },
  'jump-none': {
    extraRise: -1,
    roundingFunction: Math.floor,
  },
  'jump-both': {
    extraRise: 1,
    roundingFunction: Math.ceil,
  },
}

export function stepEasing(steps: number, jumpterm: JumpTerm) {
  const config = stepConfig[jumpterm]

  const stepLength = 1 / steps
  const stepHeight = 1 / (steps + config.extraRise)

  return (t) => {
    if (t === 0 || t === 1) {
      return t
    }
    const numberOfSteps = config.roundingFunction(t / stepLength)
    return numberOfSteps * stepHeight
  }
}
